import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { SLIDE_NUMBER } from "../constants";
import { getDateParts, getDateWithoutFrequency, getDateId } from './dateHelpers';
import { MIN_DATE } from '../constants'

export async function getCalendarMark(dictionariesService: DictionariesService, commodity: number, frequency: number) {
  const lastYearCalendar = await dictionariesService.getDictionary({
    id: 'slides-f-last-calendar',
    parameters: {
      attributes: '',
      units: '',
      commodities: commodity ? String(commodity) : "201",
      countries: '',
      slide: SLIDE_NUMBER,
    },
  });
  const calendar = await dictionariesService.getDictionary({id: "calendar-origin", parameters: {}});

  const lastYearCalendarItems = await lastYearCalendar.getAll();
  const calendarItems = await calendar.getAll();
  
  const minDate = getDateWithoutFrequency(MIN_DATE);
  const maxDate = lastYearCalendarItems[0] ? getDateWithoutFrequency(lastYearCalendarItems[0].id) : getDateWithoutFrequency(getDateId(new Date(), 7));
  const calendarMark = (calendarItems || [])
    .filter(item => item.getValue<number>('frequencyId') === frequency)
    .filter(item => minDate <= getDateWithoutFrequency(item.id) && getDateWithoutFrequency(item.id) <= maxDate)
    .map(item => Number(item.id))
    .sort((a, b) => getDateWithoutFrequency(a) - getDateWithoutFrequency(b));
  
  return {
    calendar: calendarMark,
  };
}